module.exports = __webpack_public_path__ + "img/digitalIdentity1.e09d3b13.png";